import { Action } from 'redux'
import { IProvenance } from '../../models/Provenance'
import { ProvenancesActions } from '../../reducers/provenances/actionNames'

export const requestProvenances = (modifyDate?: Date): IRequestProvenances => ({
  modifyDate,
  type: ProvenancesActions.RequestForProvenances,
})
export const acceptProvenances = (
  provenances: IProvenance[],
): IAcceptProvenances => ({
  provenances,
  type: ProvenancesActions.ProvenancesAreAccepted,
})
export const rejectProvenances = (errMessage: string): IRejectProvenances => ({
  errMessage,
  type: ProvenancesActions.ProvenancesAreRejected,
})

export interface IRequestProvenances
  extends Action<ProvenancesActions.RequestForProvenances> {
  modifyDate?: Date
}

export interface IAcceptProvenances
  extends Action<ProvenancesActions.ProvenancesAreAccepted> {
  provenances: IProvenance[]
}

export interface IRejectProvenances
  extends Action<ProvenancesActions.ProvenancesAreRejected> {
  errMessage: string
}
